import { MediaType } from '../MediaType';
import { useExperimentalQuery, type FetchPolicy } from '../useExperimentalQuery';

interface ExperimentalPromotedSpace {
	id?: string | null;
	text?: string | null;
	__typename?: 'ExperimentalPromotedSpace';
}

export interface ExperimentalPromotedSpacesData {
	experimentalPromotedSpaces: {
		nodes?: (ExperimentalPromotedSpace | null)[] | null;
		matchedPromotedSpaces?: (ExperimentalPromotedSpace | null)[] | null;
		__typename?: 'ExperimentalPromotedSpaces';
	} | null;
}

interface PromotedSpacesVariables {
	promotedSpacesLimit?: number | null;
	otherSpacesLimit?: number | null;
	promotedSpaceKey?: string | null;
}

interface PromotedSpacesAPIResponse {
	matchedPromotedSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
	promotedSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
	otherSpaces?: {
		spaces?: ExperimentalPromotedSpace[];
	};
}

export type UseExperimentalPromotedSpacesQueryParams = {
	skip?: boolean;
	onError?: (error: Error) => void;
	variables?: PromotedSpacesVariables;
	fetchPolicy?: FetchPolicy;
};

export const useExperimentalPromotedSpacesQuery = ({
	skip,
	onError,
	variables = {},
	fetchPolicy,
}: UseExperimentalPromotedSpacesQueryParams = {}) => {
	const promotedSpacesLimit = variables.promotedSpacesLimit || 10;
	const otherSpacesLimit = variables.otherSpacesLimit || 10;
	const promotedSpaceKey = variables.promotedSpaceKey || '';

	return useExperimentalQuery<
		ExperimentalPromotedSpacesData,
		PromotedSpacesVariables,
		PromotedSpacesAPIResponse
	>({
		url: `/wiki/rest/create-dialog/1.0/spaces?promotedSpacesLimit=${promotedSpacesLimit}&otherSpacesLimit=${otherSpacesLimit}&promotedSpaceKey=${promotedSpaceKey}`,
		method: 'GET',
		headers: {
			'Content-Type': MediaType.JSON,
		},
		parseResult: (json) => {
			const matchedPromotedSpaces =
				(json.matchedPromotedSpaces && json.matchedPromotedSpaces.spaces) || [];
			const nodes = ((json.promotedSpaces && json.promotedSpaces.spaces) || []).concat(
				(json.otherSpaces && json.otherSpaces.spaces) || [],
			);
			return {
				experimentalPromotedSpaces: {
					nodes,
					matchedPromotedSpaces,
					__typename: 'ExperimentalPromotedSpaces',
				},
			};
		},
		skip,
		onError,
		variables,
		fetchPolicy,
	});
};
